module.exports = __webpack_public_path__ + "media/img/ph-98aa829210389c80ee7eece4bdc3dd91.png";